// extracted by mini-css-extract-plugin
export default {"notification-card":"Sorted_notification-card__abbQ1","tablemates":"Sorted_tablemates__y21VR","section-type-1__layout":"Sorted_section-type-1__layout__Abln+"};